import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export async function generatePdf(previewRef, numero) {
  const element = previewRef.current;
  if (!element) return;

  // Esperar a que todas las imágenes del preview estén cargadas
  const images = element.querySelectorAll('img');
  await Promise.all(
    Array.from(images).map(
      (img) =>
        img.complete
          ? Promise.resolve()
          : new Promise((resolve) => {
              img.onload = resolve;
              img.onerror = resolve;
            })
    )
  );

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    allowTaint: true,
    backgroundColor: '#ffffff',
    logging: false,
    imageTimeout: 5000,
    windowWidth: 1400,
    windowHeight: 1200,
    onclone: (clonedDocument) => {
      const clonedElement = clonedDocument.querySelector('.cotizador-preview-document--screen');
      if (!clonedElement) return;

      clonedElement.classList.remove('cotizador-preview-document--screen');
      clonedElement.classList.add('cotizador-preview-document--pdf');
      Object.assign(clonedElement.style, {
        width: '794px',
        maxWidth: 'none',
        minHeight: '1000px',
        padding: '40px 48px',
        fontSize: '13px',
        boxSizing: 'border-box',
      });

      const viewport = clonedElement.closest('.cotizador-preview-viewport');
      if (viewport) {
        Object.assign(viewport.style, {
          width: '794px',
          maxWidth: 'none',
          overflow: 'visible',
          boxShadow: 'none',
        });
      }

      const scaleWrapper = clonedElement.closest('.cotizador-preview-scale');
      if (scaleWrapper) {
        Object.assign(scaleWrapper.style, {
          width: '794px',
          maxWidth: 'none',
          margin: '0',
        });
      }
    },
  });

  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const imgWidthMm = pageWidth;
  const imgHeightMm = (canvas.height / canvas.width) * pageWidth;

  let heightLeft = imgHeightMm;
  let position = 0;

  pdf.addImage(imgData, 'PNG', 0, position, imgWidthMm, imgHeightMm);
  heightLeft -= pageHeight;

  while (heightLeft > 0) {
    position -= pageHeight;
    pdf.addPage();
    pdf.addImage(imgData, 'PNG', 0, position, imgWidthMm, imgHeightMm);
    heightLeft -= pageHeight;
  }

  const numPadded = String(numero).padStart(4, '0');
  pdf.save(`presupuesto-transportes-leo-${numPadded}.pdf`);
}
